import { useState } from 'react';
import useLocalStorage from '~/hooks/use-local-storage';

const useUserDismissedFeatures = (area: string) => {
  const [hiddenNow, setHiddenNow] = useState<string[]>([]);
  const { setValue: setUserDismissedFeatures, storedValue: userDismissedFeatures } = useLocalStorage(
    `MYACCOUNT-FEATURE-DISMISS-${area}`.toUpperCase(),
    [] as string[]
  );

  const hideFeature = (feature: string) => {
    if (!userDismissedFeatures.includes(feature)) {
      setUserDismissedFeatures([...userDismissedFeatures, feature]);
    }
    setHiddenNow((prev) => [...prev, feature]);
  };

  return { hideFeature, userDismissedFeatures: [...userDismissedFeatures, ...hiddenNow] };
};

export default useUserDismissedFeatures;
